// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2Kwev","inner":"Form_inner__XXAl8","range":"Form_range__23_zk","name":"Form_name__3PDgT","actions":"Form_actions__1SNzZ"};